import { Building2 } from 'lucide-react';
import { Button } from '@/components/ui/button';

interface VendorsEmptyStateProps {
  onCreateVendor?: () => void;
}

export function VendorsEmptyState({ onCreateVendor }: VendorsEmptyStateProps) {
  return (
    <div className="flex flex-col items-center justify-center py-16 text-center">
      <div className="rounded-full bg-primary/10 p-4 mb-4">
        <Building2 className="h-8 w-8 text-primary" />
      </div>
      <h3 className="text-lg font-semibold mb-1">Manage your vendor companies</h3>
      <p className="text-muted-foreground text-sm max-w-sm mb-4">
        Create vendors to group paid canvassers by their contracting company for reporting and payment tracking.
      </p>
      {onCreateVendor && (
        <Button onClick={onCreateVendor} size="sm">
          Create First Vendor
        </Button>
      )}
    </div>
  );
}
